import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import { TextArea } from "pepsico-ds";
import useThemeRender from "../../../theme/useThemeRender";
import "./FormatableTextArea.css";

const FormatableTextArea = ({
  label,
  editorRef,
  isDarkTheme,
  setDescription,
  isDisabled = false,
  changeFormatableText,
  showToolbar,
  ...rest
}) => {
  const [localContent, setLocalContent] = useState("");

  useEffect(() => {
    setLocalContent(setDescription);
  }, [setDescription]);

  const handleBlur = (e) => {
    changeFormatableText(localContent);
  };

  const updateLocalText = (e) => {
    setLocalContent(e);
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "8px",
        width: { sm: "100%", md: "360px" },
      }}
    >
      <TextArea
        className="curator-text-area-summary"
        label={label}
        value={localContent}
        disabled={isDisabled}
        showCharacterCount
        showLabelIcon
        onUpdate={(e) => updateLocalText(e)}
        onBlur={handleBlur}
        placeholder="Type here"
        isDark={isDarkTheme}
        showToolbar={showToolbar}
        {...rest}
        style={{
          display: "flex",
          height: "122px",
          maxHeight: "122px",
          maxWidth: "min(460px, 100%)",
          padding: "var(--Spacing-spacing-8, 8px);",
          ...rest.style,
        }}
      />
    </Box>
  );
};

export default FormatableTextArea;
